<template>
    <div>
        <a-button type="primary" style="margin-left: 8px" icon="download" @click="ExportXls">导出</a-button>

        <a-tabs hide-add :active-key="activeKey" @click="handleClickTab">
            <a-tab-pane v-for="pane in FloorAreaList" :key="pane.sysfloorid" :tab="pane.floorname"
                :closable="pane.closable">
                <!-- <div :style="{ marginTop: '10px' }">
                    <a-radio-group :active-key="active" @change="handleRadioChange">
                        <a-radio-button button-style="solid" v-for="item in pane.children" :value="item.sysareaid"
                            :key="item.sysareaid">
                            {{ item.areaname }}
                        </a-radio-button>
                    </a-radio-group>

                </div> -->
                <div class="main">
                    <div class="main-content" @mousedown="down" @mousemove="move" @mouseup="up">
                        <div v-for="(area, index1) in areas" :key="index1" class="areaheader" :style="{with:area.maxRowQty*52+'px'}">{{ area.areaname }}</div>
                            <div v-for="(item, index) in area.seats" :key="index" class="list">
                                <div class="colno">{{ index + 1 }}</div>
                                <div v-for="(val, pk) in item" :key="pk" class="oplist">
                                    <div v-if="index == 0" class="rowno">{{ pk + 1 }}
                                    </div>
                                    <div v-if="val.status === '0'" class="selection "
                                        :style="{ border: bordersize + val.sgroupcolor }"></div>
                                    <div v-else-if="val.status === '1' || val.status === '2'" class="emptyseat"
                                        :style="{ border: bordersize + val.sgroupcolor }"></div>
                                    <div v-else-if="val.status === '3'" class="selection green"
                                        :style="{ border: bordersize + val.sgroupcolor }">{{ val.personname }}</div>
                                    <div v-else-if="val.status === '4'" class="selection yellow"
                                        :style="{ border: bordersize + val.sgroupcolor }">{{ val.personname }}</div>
                                    <div v-else="val.status === '5'" class="selection red"
                                        :style="{ border: bordersize + val.sgroupcolor }"></div>
                                    <!-- 0--可用/未選
                                    1--不可用
                                    2--不可見
                                    3--已選
                                    4--佔用
                                    5--鎖定 -->
                                </div>
                            </div>
                       
                    </div>
                </div>
            </a-tab-pane>
        </a-tabs>
    </div>
</template>
<script>
import { httpAction, getAction, downFile, downloadFile } from '@/api/manageChooseSeat'
import { FormTypes, getRefPromise, VALIDATE_NO_PASSED } from '@/utils/JEditableTableUtil'
import { JEditableTableModelMixin } from '@/views/chooseSeat/mixins/JEditableTableModelMixin'
import { validateDuplicateValue } from '@/utils/util'


function dataProces(areaData = null, infoList = null) {
    if (!areaData || !infoList) {
        return;
    }
    let showlist = [];
    let subset = [];
    let maxRowQty = 0;
    let maxColQty = 0;
    areaData.forEach((item, index) => {
        infoList.forEach((val, pk) => {
            if (item.sysareaid == val.sysareaid) {
                maxRowQty = item.maxRowQty;
                maxColQty = item.maxColQty;
                showlist.push(val);
            }
        })
    })
    if (showlist.length > 0) {
        for (let i = 0; i < maxRowQty; i++) {
            let attData = [];
            for (let j = 0; j < maxColQty; j++) {
                let data = [];
                data = lineData(i, j, showlist);
                attData.push(data);
            }
            subset.push(attData);
        }
    }
    console.log('座位数据:', subset)
    return subset;
}
function lineData(i = 0, j = 0, data = null) {
    let retData = [];
    data.forEach((val, pk) => {
        if (val.rowno === (i + 1) && val.colno === (j + 1)) {
            retData = val;
            return;
        }
    });
    return retData;
}
export default {
    name: 'ViewSeatForm',
    mixins: [JEditableTableModelMixin],
    inject: ['operation'],
    components: {
    },
    data() {
        return {
            activeKey: '',
            active: '',
            // form 一行布局
            labelCol1: { span: 4 },
            wrapperCol1: { span: 18 },
            // form 两行布局， 默认为两行
            labelCol2: { span: 8 },
            wrapperCol2: { span: 12 },

            url: {
                viewSeat: "/ActivitySeat/ViewSeat",
            },

            FloorList: [],
            maxrowqty: 0,//行
            maxcolqty: 0,//列
            sysfloorData: [],//默认楼层
            sysareaId: '',//默认区域
            sysfloorId: '',
            areas: [],
            subset: [],//status  0  可选座位   (白色)1  已选座位   (绿色) 2  已购票座位 (红色) 3空座


        }
    },
    props: {
        //表单禁用
        disabled: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    computed: {
        language() {
            return this.$store.getters.language
        },
        formDisabled() {
            return this.disabled
        },
        areaheaderwith(area)
        {
            return area.maxRowQty*52;
        }
    },
    created() {
        this.getFloorData();
    },
    watch: {

    },
    mounted() {

    },
    methods: {
        getFloorData(sysactivityid = this.operation.sysactivityid, sysvenueid = this.operation.sysvenueid) {
            var that = this;
            this.subset = [];

            getAction('/ActivityInfo/seatAssignDetail', { sysvenueid, sysactivityid }).then((res) => {
                if (res.success) {

                    let floor = [];
                    that.FloorAreaList = res.result.records;

                    floor = res.result.records.find((item) => item.sysfloorid === that.sysfloorData.sysfloorid);
                    //如果當前樓層在更新後的數據中找不到就取默認樓層
                    if (!floor) {
                        floor = res.result.records[0];
                    }
                    that.sysfloorData = floor;//設置當前樓層
                    if (floor) {
                        // let area = floor.children.find((item) => item.sysareaid === that.sysareaData.sysareaid)
                        // if (!area) {
                        //     area = floor.children[0];//当前区域
                        // }
                        // that.sysareaData = area;//当前区域

                        that.activeKey = that.sysfloorData.sysfloorid;
                        that.sysfloorid = that.sysfloorData.sysfloorid;
                        // that.active = that.sysareaData.sysareaid;
                        // that.sysareaid = that.sysareaData.sysareaid;

                        //取默认行列
                        // that.maxRowQty = that.sysareaData.maxRowQty;//行
                        // that.maxColQty = that.sysareaData.maxColQty;//列
                        let area = { name: '', seats: [] };
                        let seats = [];
                        //查询默认楼层座位
                        for (let i = 0; i < floor.children.length; i++) {
                            seats = dataProces(that.sysfloorData.children, floor.children[i].activitySeat);
                            area.name = floor.children[i].areaname;
                            area.seats = seats;
                            that.areas.push(area);
                        }


                    }

                }
            })
        },
        handleClickTab(v) { //楼层选择
            const innerText = v.target.innerText;
            let tablist = this.FloorList;
            console.log(innerText);
            if (tablist.length > 0) {
                tablist.forEach((item, index) => {
                    if (item.floorname === innerText) {
                        this.subset = [];
                        this.sysfloorData = item;
                        this.activeKey = item.sysfloorid
                        this.sysfloorId = item.sysfloorid
                    }
                })
            }
        },
        ExportXls() {
            let url = window._CONFIG['chooseSeatDomainURL'] + "/ActivityInfo/exportActivitySeatInfo?sysactivityid=" + this.operation.sysactivityid + "&sysvenueid=" + this.operation.sysvenueid
            downloadFile(url, 'SeatInfo.xlsx');

        },


    }
}
</script>

 
<style scoped>
.main {
    float: left;
    width: 100%;
    height: 650px;
    background: #fff;
    margin-top: 50px;
}

.main-content {
    min-height: 550px;
}

.areaheader
{
    float: left;
    height: 25px;
}
.list {
    float: left;
    width: 100%;
}

.oplist {
    float: left;
}

.selection {
    display: flex;
    flex-direction: column;
    border: 2px solid #b4b0b0;
    text-align: center;
    line-height: 20px;
    width: 50px;
    height: 25px;
    background: #F2F2F2;
    margin: 0px;
}


/* 0 可用、未选灰色，1和2 都不可見，3 已选 綠色，4 占位 黃色，5 锁定 红色*/
.red {
    background: #f00;
    color: #fff;
}

.yellow {
    background: #f0a645;
}

.green {
    background: #11df0dd9;
}

.emptyseat {
    display: flex;
    flex-direction: column;
    width: 40px;
    height: 25px;
    margin: 0px;
}

.colno {
    float: left;
    width: 50px;
    height: 25px;
    margin: 0px;
    border: 1px solid #dcdcdc;
    background: #81D3F8;
    color: #fff;
    text-align: center;
    line-height: 30px;
}

.rowno {
    width: 50px;
    height: 25px;
    margin: 0px;
    border: 1px solid #dcdcdc;
    background: #FACD91;
    color: #fff;
    position: absolute;
    top: 130px;
    text-align: center;
    line-height: 30px;
}

.test {
    width: 80vw;

    border: 1px solid #000000;

    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
}

.item {

    display: inline-block;
    padding: 50px;
    margin: 30px;

    background: #0088ff;
    user-select: none;

}

.selected {
    background-color: black;
}

.move {
    position: fixed;
    top: v-bind("movable.top");
    left: v-bind("movable.left");
    width: v-bind("movable.width");
    height: v-bind("movable.height");
    background: rgba(234, 23, 135, 0.3);
}
</style>